import React from 'react';
import { motion, MotionValue, useTransform } from 'framer-motion';
type ScrollRevealWordProps = {
  word: string;
  progress: MotionValue<number>;
  range: [number, number];
};
export function ScrollRevealWord({
  word,
  progress,
  range
}: ScrollRevealWordProps) {
  const opacity = useTransform(progress, range, [0.18, 1]);
  return <motion.span style={{
    opacity
  }} data-id="element-415" data-mp="2x98ef9l34h8d">{word} </motion.span>;
}